import React, { useState } from 'react';
import logo from '../Assets/headerlogo.png';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleStartDesigningClick = () => {
    navigate('/sign-in');
    setIsMobileMenuOpen(false);
  };

  const handleSamplesClick = () => {
    navigate('/samples');
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 100; // Approximate header height
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className="flex items-center justify-between flex-wrap gap-5 py-6 px-6 w-full text-lg font-medium tracking-wide text-black" style={{ backgroundColor: '#9CAE88' }}>
        {/* Logo */}
        <img
          loading="lazy"
          src={logo}
          alt="NOSTAi logo"
          className="w-40 h-7 mr-2"
        />

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-6">
          <button 
            onClick={() => scrollToSection('how-nostai-works')}
            style={{ fontFamily: "Playfair Display" }} 
            className="text-black hover:text-gray-700 transition-colors text-lg"
          >
            How NOSTAi Works
          </button>
          <button 
            onClick={() => scrollToSection('quilt-calculator')}
            style={{ fontFamily: "Playfair Display" }} 
            className="text-black hover:text-gray-700 transition-colors text-lg"
          >
            Quilt Calculator
          </button>
          <button 
            onClick={() => scrollToSection('help-guide')}
            style={{ fontFamily: "Playfair Display" }} 
            className="text-black hover:text-gray-700 transition-colors text-lg"
          >
            Help Guide
          </button>
          <button onClick={handleStartDesigningClick} style={{ fontFamily: "Playfair Display" }} className="gap-2.5 py-2 px-4 bg-[#FFF8F0] text-lg rounded-lg">
            Design your Quilt
          </button>
        </nav>

        {/* Mobile Hamburger Menu Button */}
        <button 
          onClick={toggleMobileMenu}
          className="md:hidden flex flex-col gap-1 p-2"
          aria-label="Toggle mobile menu"
        >
          <div className={`w-6 h-0.5 bg-black transition-all duration-300 ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></div>
          <div className={`w-6 h-0.5 bg-black transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : ''}`}></div>
          <div className={`w-6 h-0.5 bg-black transition-all duration-300 ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></div>
        </button>
      </header>

      {/* Mobile Dropdown Menu */}
      <div className={`md:hidden fixed top-0 left-0 right-0 w-full z-50 transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'}`} style={{ backgroundColor: '#F6E8E0', marginTop: '88px' }}>
        <nav className="flex flex-col py-4 px-6 shadow-lg">
          <button 
            onClick={() => scrollToSection('how-nostai-works')}
            style={{ fontFamily: "Playfair Display" }} 
            className="text-black hover:text-gray-700 transition-colors text-lg py-3 text-center border-b border-gray-300 last:border-b-0"
          >
            How NOSTAi Works
          </button>
          <button 
            onClick={() => scrollToSection('quilt-calculator')}
            style={{ fontFamily: "Playfair Display" }} 
            className="text-black hover:text-gray-700 transition-colors text-lg py-3 text-center border-b border-gray-300 last:border-b-0"
          >
            Quilt Calculator
          </button>
          <button 
            onClick={() => scrollToSection('help-guide')}
            style={{ fontFamily: "Playfair Display" }} 
            className="text-black hover:text-gray-700 transition-colors text-lg py-3 text-center border-b border-gray-300 last:border-b-0"
          >
            Help Guide
          </button>
          <button 
            onClick={handleStartDesigningClick} 
            style={{ fontFamily: "Playfair Display" }} 
            className="mt-4 py-3 px-6 bg-[#9CAE88] text-black text-lg rounded-lg text-center mx-auto max-w-xs"
          >
            Design your Quilt
          </button>
        </nav>
      </div>

      {/* Background overlay for mobile menu */}
      {isMobileMenuOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black bg-opacity-25 z-40"
          onClick={toggleMobileMenu}
        ></div>
      )}
    </>
  );
};

export default Header;
